import { MgItemPackageDTO } from '../../dto/mgItem/MgItemPackageDTO';
import { PackageType } from '../HierarchyLevels';
import { Unit } from '../price';

interface Props {
  gtinCode: string;
  unit: Unit;
  isBasePriceUnit: boolean;
  calculatedCount: number;
  classCode: string;
  packageType: PackageType;
}

export class MgItemPackage {
  gtinCode: string;
  unit: Unit;
  isBasePriceUnit: boolean;
  calculatedCount: number;
  classCode: string;
  packageType: PackageType;

  constructor({ gtinCode, unit, isBasePriceUnit, calculatedCount, classCode, packageType }: Props) {
    this.gtinCode = gtinCode;
    this.unit = unit;
    this.isBasePriceUnit = isBasePriceUnit;
    this.calculatedCount = calculatedCount;
    this.classCode = classCode;
    this.packageType = packageType;
  }
  static fromDto = (dto: MgItemPackageDTO): MgItemPackage =>
    new MgItemPackage({
      gtinCode: dto.gtinCode,
      unit: Unit.fromDto(dto.unit),
      isBasePriceUnit: dto.isBasePriceUnit,
      calculatedCount: dto.calculatedCount,
      classCode: dto.classCode,
      packageType: dto.packageType,
    });
}
